<template>
  <div class="lease-distance-container">
    <p class="col-12 text-primary text-weight-bolder" style="font-size: 16px; margin: 0 0 5px">KM driven annually</p>
    <QInput v-model="leaseDistance" class="lease-distance-input q-mr-sm" outlined dense readonly>
      <template v-slot:append>
        <QIcon :name="infoIcon" style="rotate: 180deg">
          <QTooltip class="bg-white text-black shadow-4" :offset="[0, 10]" max-width="280px" anchor="bottom right" self="top left">
            Estimates are based on driving 15,000km per year. If you proceed to a quote, you can adjust your kilometres to match your
            driving pattern.
          </QTooltip>
        </QIcon>
      </template>
    </QInput>
  </div>
</template>

<script>
import { QInput, QIcon, QTooltip } from 'quasar';
import { evaAlertCircleOutline } from '@quasar/extras/eva-icons';

export default {
  name: 'LeaseDistance',
  data() {
    return {
      leaseDistance: this.formatValue()
    };
  },
  props: {
    value: {
      type: Number
    }
  },
  computed: {},
  created() {
    this.infoIcon = evaAlertCircleOutline;
  },
  methods: {
    formatValue: function () {
      const value = this.value;
      return `${value.toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}km`;
    }
  },
  components: {
    QInput,
    QIcon,
    QTooltip
  }
};
</script>
<style lang="sass">
.q-tooltip--style
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03)
  background: #fff !important
  color: #424242 !important
  border: 1px solid rgba(0, 0, 0, 0.05)
  padding: 18px
.lease-distance-input.q-input .q-field__append
  opacity: 1
</style>
